package com.macrofocus.eflux.components.link

import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px
import web.url.URL

external interface SalesforceLinkProps : Props {
    var url: String?
    var link: Boolean?
}

val SalesforceLink = FC<SalesforceLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        if(props.link != true) {
            component = Button
        } else {
            href = props.url
        }
        onClick = {
            if(props.url != null) {
                window.open(props.url!!, "_blank")
            }
        }

        if(props.link == true) {
            +secondLastPathSegment(props.url)
        } else {
            +"Salesforce"
        }
    }
}

fun secondLastPathSegment(urlString: String?): String? {
    if(urlString == null) return null
    val url = URL(urlString) // Uses the browser's built-in URL class
    val segments = url.pathname
        .trim('/')
        .split('/')
        .filter { it.isNotEmpty() }

    return if (segments.size >= 2) segments[segments.size - 2] else null
}